// extracted by mini-css-extract-plugin
export default {"invalid":"Seller_invalid__6Xarz"};